import React from "react";
import type { ImportPreviewRow } from "@/model/interface/DataImport";

interface ImportPreviewStepProps {
  rowCount: number;
  previewRows: ImportPreviewRow[];
}

export default function ImportPreviewStep({ rowCount, previewRows }: ImportPreviewStepProps) {
  if (previewRows.length === 0) {
    return <p className="text-sm text-muted-foreground">The file has no rows to import.</p>;
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        The first {previewRows.length} of <span className="tabular-nums">{rowCount.toLocaleString()}</span> rows, as
        they will be saved.
      </p>
      <div className="max-h-[55vh] space-y-3 overflow-auto pr-1">
        {previewRows.map((row) => (
          <div key={row.rowNumber} className="space-y-1.5 rounded-[var(--radius)] border border-border p-4">
            <div className="flex items-center justify-between gap-3">
              <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                Row {row.rowNumber}
              </span>
              {row.errors.length > 0 && (
                <span className="status-pill-warning tabular-nums">
                  {row.errors.length === 1 ? "1 issue" : `${row.errors.length} issues`}
                </span>
              )}
            </div>
            {row.lines.map((line, index) => (
              <p key={index} className="text-sm">
                {line}
              </p>
            ))}
            {row.errors.map((error, index) => (
              <p key={`error-${index}`} className="text-sm text-destructive">
                {error}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
